import { useState } from 'react';
import './productEducationalMedia.css';

function isSafeMediaUrl(value) {
  if (!value) return false;
  if (/^\/(?!\/)/.test(value)) return true;

  try {
    const url = new URL(value);
    return url.protocol === 'https:' || url.protocol === 'http:';
  } catch {
    return false;
  }
}

function ProductEducationalMedia({ product }) {
  const [videoFailed, setVideoFailed] = useState(false);
  const media = product?.educationalMedia;
  const mp4Url = isSafeMediaUrl(media?.videoUrl) ? media.videoUrl : '';
  const webmUrl = isSafeMediaUrl(media?.videoWebmUrl) ? media.videoWebmUrl : '';

  if (!media?.enabled || media.mediaType !== 'video' || (!mp4Url && !webmUrl)) return null;

  const title = media.title || `How to use ${product.name}`;

  return (
    <section aria-labelledby="product-video-title" className="product-media-section">
      <header className="product-media-section__header">
        <p className="eyebrow">How to Use</p>
        <h2 id="product-video-title">{title}</h2>
        <p>{media.description || 'A visual guide showing the approved method of use.'}</p>
      </header>
      {videoFailed ? (
        <p className="product-media__fallback" role="status">This product video is temporarily unavailable.</p>
      ) : (
        <div className="product-media__video-frame">
          <video
            aria-label={`${title} video`}
            controls
            onError={() => setVideoFailed(true)}
            playsInline
            poster={isSafeMediaUrl(media.posterUrl) ? media.posterUrl : undefined}
            preload="metadata"
          >
            {webmUrl ? <source src={webmUrl} type="video/webm" /> : null}
            {mp4Url ? <source src={mp4Url} type="video/mp4" /> : null}
            {isSafeMediaUrl(media.captionsUrl) ? <track default kind="captions" label="English" src={media.captionsUrl} srcLang="en" /> : null}
            Your browser does not support HTML5 video.
          </video>
        </div>
      )}
    </section>
  );
}

export default ProductEducationalMedia;
